'use strict';

var supplyChainUrls = {
	purchasePriceVarience: {
		chart: urlPfx + '/YTDPurchasePriceVariance'
	},
	ppvIncreaseBySupplier: {
		table: urlPfx + '/PPVIncreaseBySupplierDetail',
		headers: urlPfx + '/PPVIncreaseBySupplierTotals'
	}
};

angular.module('widgets.supplychain', ['adf.provider'])
	.filter('daysSinceLastAccess', function ($translate) {
		var notRegisteredKey = 'Not registered';
		var neverKey = 'Never';
		var unknownKey = 'Unknown';
		var todayKey = 'Today';
		var yesterdayKey = 'Yesterday';
		var daysAgoKey = 'days ago';
		var mumKey = 'Multiple users match';

		$translate('Never').then(function (never) {
			neverKey = never;
		});
		$translate('Not registered').then(function (nr) {
			notRegisteredKey = nr;
		});
		$translate('Unknown').then(function (unknown) {
			unknownKey = unknown;
		});
		$translate('Today').then(function (today) {
			todayKey = today;
		});
		$translate('Yesterday').then(function (yesterday) {
			yesterdayKey = yesterday;
		});
		$translate('days ago').then(function (da) {
			daysAgoKey = da;
		});
		$translate('Multiple users match').then(function (mum) {
			mumKey = mum;
		});

		return function (lastAccessDate) {
			if (typeof lastAccessDate === 'undefined' || lastAccessDate === null || lastAccessDate === '')
				return notRegisteredKey;
			if (lastAccessDate === 'Never')
				return neverKey;
			if (lastAccessDate === 'Duplicate')
				return mumKey;
			var utcLastAccessDate = new Date(lastAccessDate);
			var now = new Date();
			var timeDiff = now - utcLastAccessDate;
			if (timeDiff < 0)
				return unknownKey;
			var days = Math.floor(timeDiff / (1000 * 3600 * 24));
			switch (days) {
			case 0:
				return todayKey;
			case 1:
				return yesterdayKey;
			default:
				return days + ' ' + daysAgoKey;
			}
		};
	})
	.config(function (dashboardProvider) {
		var widgetPPV = {
			name: 'Purchase Price Variance (PPV)',
			description: 'The monthly and cumulative Purchase Price Variance for the last 6 months, last 12 months, or current fiscal year.',
			thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/PPVGraph.png',
			categories: ['All', 'Supplier Performance'],
			config: {},
			slideshowView: true,
			isActive: true,
			templateUrl: '/application/f/dashboard/widgets/ppv.html',
			drillDownUrl: '/application/f/home.html#/supply-chain/spend-analytics/supplier-spend/?drilldown=1',
			reload: true,
			isDrillDown: true,
			isEditable: true,
			resolve: {
				title: function (config) {
					if (config.title) {
						return config.title;
					}
				},
				timePeriod: function (config) {
					if (config.timePeriod) {
						return config.timePeriod;
					}
				}
			}
		};

		var widgetPPVIncreaseBySupplier = {
			name: 'PPV Increase By Supplier',
			description: 'Displays the total monthly Purchase Price Variance (PPV) Increase per supplier.',
			thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/table.png',
			categories: ['All', 'Supplier Performance'],
			config: {},
			slideshowView: false,
			isActive: true,
			templateUrl: '/application/f/dashboard/widgets/ppvIncreaseBySupplier.html',
			drillDownUrl: '/application/f/home.html#/supply-chain/spend-analytics/supplier-spend/?drilldown=1',
			reload: true,
			isDrillDown: true
		};
		// register Buyer Widgets
		dashboardProvider
			.widget('purchasePriceVarience', angular.extend({
				controller: 'purchasePriceVarienceCtrl'
			}, widgetPPV))
			.widget('ppvIncreaseBySupplier', angular.extend({
				controller: 'ppvIncreaseBySupplierCtrl'
			}, widgetPPVIncreaseBySupplier));
	})

	.controller('purchasePriceVarienceCtrl',
		function ($rootScope, $scope, $timeout, $translate, hostUrl, getJsonData, dashboardFilterInitializationService, leanFilterService,
			pageTimingService, timePeriod, storeService) {
			$scope.filterService = dashboardFilterInitializationService;
			$scope.leanFilterService = leanFilterService;
			$scope.$parent.$parent.showViewReport = true;
			$scope.$parent.$parent.editTitle = 'Edit PPV time period configuration';
			$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
			if (!$scope.$parent.content.defaultDrillDownUrl) {
				$scope.$parent.content.defaultDrillDownUrl = $scope.$parent.content.drillDownUrl;
			}

			$scope.timePeriod = {};
			$scope.slideshowView = $rootScope.slideshowView;
			$scope.timePeriods = [
				{
					'timePeriodName': $translate.instant('Current Fiscal Year'),
					'id': 'current'
				},
				{
					'timePeriodName': $translate.instant('12 Months Back'),
					'id': '12'
				},
				{
					'timePeriodName': $translate.instant('6 Months Back'),
					'id': '6'
				}
			];

			function checkForTimePeriod() {
				if (timePeriod) {
					var selectedTimePeriod = _.find($scope.timePeriods , function (timePeriodObj) {
						return timePeriodObj.id == timePeriod.id;
					});
					if (selectedTimePeriod == null) {
						selectedTimePeriod = $scope.timePeriods[0];
					}
					$scope.timePeriod = selectedTimePeriod;
					$scope.timePeriodSelect = false;
					getChart();
					$scope.$parent.$parent.hidePencil = false;
				} else {
					$scope.$parent.$parent.hidePencil = true;
					$scope.timePeriodSelect = true;
					$scope.timePeriod = $scope.timePeriods[0];
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					if (!$scope.slideshowView) {
						pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
				}
			}

			function updatePPVWidgetConfig() {
				var ppvModel = $scope.$parent.model;
				if ($scope.useConfig) {
					if (!ppvModel.config.timePeriod) {
						ppvModel.config.timePeriod = {};
					}
					ppvModel.config.timePeriod = $scope.timePeriod;
				}
				var columnDefinition = $scope.$parent.$parent.col;
				storeService.dispatch({
					type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
					payload: {
						column: 'column' + columnDefinition.columnIndex,
						position: columnDefinition.widgets.indexOf(ppvModel),
						widget: {
							name: ppvModel.config.type,
							config: _.cloneDeep(ppvModel.config)
						}
					},
					meta: {
						reportName: undefined,
						reportSettingsId: globalReportName
					}
				});
			}

			$scope.saveTimePeriod = function (timePeriod) {
				if (timePeriod !== null) {
					pendo.track('widgetChangeConfig', {
						widgetType: $scope.config.type,
						timePeriod: timePeriod.id
					});
					$scope.useConfig = true;
					$scope.timePeriodSelect = false;
					$scope.$parent.$parent.hidePencil = false;
					updatePPVWidgetConfig();
					getChart();
				}
			};

			function getChart() {
				var filtersToAdd = $scope.leanFilterService.getQueryParamsObject(true, true);
				filtersToAdd['factory'] = $scope.leanFilterService.getFactoryList();
				if (!jQuery.isEmptyObject(filtersToAdd)) {
					$scope.$parent.content.drillDownUrl = addQueryParam(
						$scope.$parent.content.defaultDrillDownUrl, null, filtersToAdd, false);
				} else {
					$scope.$parent.content.drillDownUrl = $scope.$parent.content.defaultDrillDownUrl;
				}

				var filtersQueryParams = $scope.leanFilterService.getQueryParamsObject(true);
				filtersQueryParams['timePeriod'] = $scope.timePeriod.id;
				var url = addQueryParam(supplyChainUrls.purchasePriceVarience.chart,
					$scope.leanFilterService.getFactoryList(), filtersQueryParams, false);
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				getJsonData.get(hostUrl + url).then(
					function (response) {
						$scope.empty = false;
						if (!response || !response.data || !response.data.length || !response.data[0]) {
							$scope.empty = true;
						} else {
							var responseData = response.data;
							var data = [];
							$scope.currency = response.currency;
							var firstMonth = new Date();
							var numMonths = Object.keys(responseData[0]).length;
							firstMonth = new Date(firstMonth.getFullYear(), firstMonth.getMonth(), 1);
							firstMonth.setMonth(firstMonth.getMonth() - numMonths + 1, 1);
							var cumulativeAmount = 0;
							var y = 0;
							for (var i = numMonths - 1; i >= 0; i--) {
								var amount = responseData[0]['month' + i] * -1;
								data.push({
									date: new Date(firstMonth),
									ppv: amount,
									cumulative: cumulativeAmount + amount
								});
								firstMonth.setMonth(firstMonth.getMonth() + 1, 1);
								cumulativeAmount = cumulativeAmount + amount;
							}
							$scope.chartData = data;
							$scope.$broadcast('event:purchasePriceVarienceCtrl:getChart', null);
							if (!$scope.slideshowView) {
								pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
							}
						}
					},
					function (e) {
						$scope.empty = true;
						$scope.timePeriodSelect = false;
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					}
				);
			}

			$scope.$parent.$parent.editWidgetSettings = function () {
				$scope.timePeriodSelect = true;
				$scope.$parent.$parent.hidePencil = true;
			};

			updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged', 'adfItemGroupChanged', 'adfSupplierChanged', 'slideshowViewChanged', 'adfBusinessUnitChanged']);
			var loadData = function () {
				if (!dashboardFilterInitializationService.updating['initialLoad']) {
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					if (!$scope.slideshowView) {
						dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
					checkForTimePeriod();
				} else {
					$timeout(loadData, 100);
				}
			};

			loadData();
		}
	)

	.directive('directivePurchasePriceVarience', ['$compile', '$window', '$rootScope', 'hostUrl',
		'getJsonData', 'currencyFormatService', '$translate', '$filter', function (
			$compile, $window, $rootScope, hostUrl, getJsonData, currencyFormatService, $translate, $filter) {
			var tooltip1 = 'PPV';
			var tooltip2 = 'Cumulative';
			tooltip1 = $translate.instant('PPV');
			tooltip2 = $translate.instant('Cumulative');

			return directiveFn2($compile, $window, $filter, $rootScope, hostUrl, getJsonData,
				'event:purchasePriceVarienceCtrl:getChart', 'date', 'ppv', 'cumulative',
				'YTD Purchase Price Variance (PPV)', tooltip1, tooltip2, currencyFormatService,
				'#37C074', '#37C074', '#FF9B30');
		}])

	.controller('ppvIncreaseBySupplierCtrl',
		function ($rootScope, $scope, $timeout, hostUrl, getJsonData, $filter, $translate, 
			dashboardFilterInitializationService, leanFilterService, pageTimingService) {
			$scope.leanDirFactNdx = globalConfig.factory.id;
			$scope.filterService = dashboardFilterInitializationService;
			$scope.leanFilterService = leanFilterService;

			if (!$scope.$parent.content.defaultDrillDownUrl) {
				$scope.$parent.content.defaultDrillDownUrl = $scope.$parent.content.drillDownUrl;
			}

			$scope.increaseLbl = 'Increase';
			$translate('Increase').then(function (increase) {
				$scope.increaseLbl = increase;
			});
			$scope.empty = true;
			$scope.$parent.$parent.showViewReport = true;

			function getTable() {
				var filtersToAdd = $scope.leanFilterService.getQueryParamsObject(true, true);
				filtersToAdd['factory'] = $scope.leanFilterService.getFactoryList();

				if (!jQuery.isEmptyObject(filtersToAdd)) {
					$scope.$parent.content.drillDownUrl = addQueryParam($scope.$parent.content.defaultDrillDownUrl,
						null, filtersToAdd, false);
				} else {
					$scope.$parent.content.drillDownUrl = $scope.$parent.content.defaultDrillDownUrl;
				}

				$scope.haveTableData = false;
				$scope.haveHeadersData = false;
				var filtersQueryParams = $scope.leanFilterService.getQueryParamsObject(true);
				var url = addQueryParam(supplyChainUrls.ppvIncreaseBySupplier.table,
					$scope.leanFilterService.getFactoryList(), filtersQueryParams, false);
				var headersUrl = addQueryParam(supplyChainUrls.ppvIncreaseBySupplier.headers,
					$scope.leanFilterService.getFactoryList(), filtersQueryParams, false);
				$scope.extraFilters = getQueryParam({
					'itemGroupNdx': filtersToAdd['itemGroupNdx'],
					'notItemGroupNdx': filtersToAdd['notItemGroupNdx']
				}, false);
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				getJsonData.get(hostUrl + url).then(
					function (responseData) {
						var d = [];
						if (responseData) {
							$scope.currency = responseData.currency;
							d = responseData.data;
						}
						angular.forEach(d, function (data) {
							var stringArray = data.supplierNdxs.split(',');
							angular.forEach(stringArray, function (s) {
								var factSupplyNdxArray = s.split('|');
								data.factoryNdx = factSupplyNdxArray[1];
								data.supplierNdx = factSupplyNdxArray[0];
							});

						});
						$scope.data = d;
						$scope.haveTableData = true;
						$scope.empty = false;
						pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					},
					function (e) {
						$scope.error = e;
						$scope.empty = true;
						pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					}
				);
				getJsonData.get(hostUrl + headersUrl).then(
					function (responseData) {
						var d = {};
						if (responseData) {
							$scope.currency = responseData.currency;
							d = responseData.data;
						}
						$scope.haveHeadersData = true;

						$scope.headerData = d;

						$scope.getHeaderForMonth = function (monthNumber) {
							var prefix = 'month' + monthNumber;
							var monthDate = $scope.headerData[prefix + 'Date'];
							var monthNameAbbreviation = (($filter('date')(monthDate, 'MMM')) || '').toUpperCase();
							var monthIncreaseTotal = $filter('currency')($scope.headerData[prefix + 'TotalIncrease'],
								$scope.currency, 0);
							return monthNameAbbreviation + ' ' + $scope.increaseLbl + ': ' + monthIncreaseTotal;
						};
					},
					function (e) { $scope.error = e; }
				);
			}

			updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged', 'adfItemGroupChanged', 'adfSupplierChanged', 'slideshowViewChanged', 'adfBusinessUnitChanged']);
			var loadData = function () {
				if (!dashboardFilterInitializationService.updating['initialLoad']) {
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
					getTable();
				} else {
					$timeout(loadData, 100);
				}
				
			};
			loadData();
		}
	);
